import { configurationService } from '../../helpers/services/configuration.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 },
  },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const CONFIGURATION_MODULE = 'configuration'

export const GET_ALL_CONFIGURATION = 'getAllConfiguration'
export const GET_CONFIGURATION = 'getConfiguration'
export const UPDATE_CONFIGURATION = 'updateConfiguration'

const REQUESTING = 'requesting'
const ALL_CONFIG_SUCCESS = 'allConfigSuccess'
const GET_CONFIG_SUCCESS = 'getConfigSuccess'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'

function mapConfigRow(item) {
  return {
    key: item.key,
    value: item.value,
    valueType: item.value_type,
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_CONFIGURATION]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    configurationService
      .getAllConfigurations(filter)
      .then((result) => {
        commit(ALL_CONFIG_SUCCESS, { data: result })
        commit(SUCCESS)
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [GET_CONFIGURATION]({ commit }, { key }) {
    commit(REQUESTING, 'detail')
    return configurationService
      .getConfiguration(key)
      .then((result) => {
        commit(GET_CONFIG_SUCCESS, result)
        commit(SUCCESS)
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [UPDATE_CONFIGURATION]({ commit, dispatch }, { key, value, filter }) {
    commit(REQUESTING, 'save')
    return configurationService
      .updateConfiguration(key, value)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.configuration')]))
        commit(SUCCESS)
        if (filter) dispatch(GET_ALL_CONFIGURATION, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
}

export const mutations = {
  [ALL_CONFIG_SUCCESS](state, { data }) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapConfigRow) : items
  },
  [GET_CONFIG_SUCCESS](state, data) {
    state.details = mapConfigRow(data.data || {})
  },
  [FAILURE](state) {
    state.status = { list: true, detail: true, save: true }
  },
  [REQUESTING](state, type) {
    state.status[type] = false
  },
  [SUCCESS](state) {
    state.status = { list: true, detail: true, save: true }
  },
}
